import { createSelector } from '@reduxjs/toolkit';
import { DATA_SLICE_KEY } from './dataSlice';

const selectSlice = (state) => state[DATA_SLICE_KEY];

/**
 * @returns {object[]} Raw lots array from the data slice.
*/
export const selectLots = (state) => selectSlice(state).lots;

/**
 * @returns {string|null} The lotId of the currently selected lot, or null if none.
*/
export const selectSelectedLotId = (state) => selectSlice(state).viewState.activeViewContext.selectedLotId;

/**
 * Derives an O(1) lookup map from the lots array.
 * Memoized — recomputes only when the lots reference changes.
 *
 * Input (store):  [{ lotId: 'g0_l7', status: 'available' }, { lotId: 'g0_l8', status: 'sold' }, ...]
 * Output:         { 'g0_l7': 'available', 'g0_l8': 'sold', ... }
 *
 * The store holds the canonical array (preserves order, supports future add/remove operations).
 * This selector converts it to an object once so consumers can do lotStatusMap[lotId] in O(1)
 * instead of a O(n) .find() on every SVG element during applyInitialColors.
 * Returns statuses only — CSS class mapping belongs in the DOM component.
 */
export const selectLotStatusMap = createSelector(
  [selectLots],
  (lots) => Object.fromEntries(lots.map((lot) => [lot.lotId, lot.status]))
);
